/* NewJaisa collection card helpers (loaded with defer from main-collection /
   main-search). Two responsibilities only:

   1. Image dots: one delegated click listener swaps the card image to the
      chosen media. Nothing is downloaded until a dot is tapped.
   2. njCollectionCardsInit(root): re-attaches the theme's existing AJAX
      add-to-cart handler (cart.js getATCelement) to cards that were inserted
      by AJAX filtering / sorting / pagination. It never duplicates bindings:
      collection-filter.js only calls it with the container whose innerHTML
      was just replaced, so every [data-add-to-cart] inside is a fresh node.
*/
(function () {
  'use strict';

  function swapImage(dot) {
    var card = dot.closest('.nj-card');
    if (!card) return;
    var img = card.querySelector('.nj-card__frame img.product-image');
    var src = dot.getAttribute('data-src');
    if (!img || !src) return;
    if (img.getAttribute('src') !== src) {
      img.classList.remove('lazyload');
      img.removeAttribute('data-src');
      img.removeAttribute('data-srcset');
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
      img.src = src;
      img.classList.add('lazyloaded');
    }
    var dots = card.querySelectorAll('[data-nj-dot]');
    for (var i = 0; i < dots.length; i++) {
      dots[i].classList.toggle('is-active', dots[i] === dot);
    }
  }

  document.addEventListener('click', function (event) {
    var dot = event.target.closest && event.target.closest('[data-nj-dot]');
    if (!dot) return;
    event.preventDefault();
    event.stopPropagation();
    swapImage(dot);
  });

  /* ---- Virtual pager for the globally ordered grid ([data-nj-priority]) ----
     The section prints EVERY card of the filtered result, already grouped
     in stock -> pre-order -> sold out. This only decides which slice is
     visible. Page number lives in ?vp=N (Shopify's own ?page is unusable
     here, see sections/main-collection.liquid). One delegated click listener
     and one popstate listener for the whole page; nothing per card. */
  function getGrid() { return document.querySelector('[data-nj-priority]'); }

  function currentVp() {
    try {
      var vp = parseInt(new URLSearchParams(window.location.search).get('vp'), 10);
      return vp > 0 ? vp : 1;
    } catch (e) { return 1; }
  }

  function showPage(page, opts) {
    opts = opts || {};
    var grid = getGrid();
    if (!grid) return;
    var size = parseInt(grid.getAttribute('data-nj-page-size'), 10) || 18;
    var items = grid.querySelectorAll(':scope > .nj-product-grid__item');
    var pages = Math.max(1, Math.ceil(items.length / size));
    page = Math.min(Math.max(1, page || 1), pages);
    for (var i = 0; i < items.length; i++) {
      items[i].hidden = Math.floor(i / size) + 1 !== page;
    }
    grid.setAttribute('data-nj-ready', '');
    grid.setAttribute('data-nj-current', page);

    var pager = grid.querySelector('[data-nj-vpager]');
    if (pager) {
      var lis = pager.querySelectorAll('[data-nj-vpage]');
      for (var j = 0; j < lis.length; j++) {
        lis[j].classList.toggle('active', parseInt(lis[j].getAttribute('data-nj-vpage'), 10) === page);
      }
      var prev = pager.querySelector('[data-nj-vprev]');
      var next = pager.querySelector('[data-nj-vnext]');
      if (prev) prev.classList.toggle('disabled', page <= 1);
      if (next) next.classList.toggle('disabled', page >= pages);
    }

    if (opts.push) {
      try {
        var u = new URL(window.location.href);
        if (page > 1) u.searchParams.set('vp', page); else u.searchParams.delete('vp');
        window.history.pushState({ njvp: page }, '', u.toString());
      } catch (e) {}
    }
    if (opts.scroll) {
      var top = grid.getBoundingClientRect().top + window.pageYOffset - 150;
      window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
    }
    if (window.lazySizes && window.lazySizes.loader && window.lazySizes.loader.checkElems) {
      window.lazySizes.loader.checkElems();
    }
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('[data-nj-vpager] a');
    if (!link) return;
    event.preventDefault();
    var li = link.closest('li');
    if (!li || li.classList.contains('disabled') || li.classList.contains('active')) return;
    var grid = getGrid();
    var cur = parseInt((grid && grid.getAttribute('data-nj-current')) || '1', 10);
    var target = cur;
    if (li.hasAttribute('data-nj-vprev')) target = cur - 1;
    else if (li.hasAttribute('data-nj-vnext')) target = cur + 1;
    else target = parseInt(li.getAttribute('data-nj-vpage'), 10) || 1;
    showPage(target, { push: true, scroll: true });
  });

  window.addEventListener('popstate', function () {
    if (getGrid()) showPage(currentVp(), {});
  });

  function initPager(reset) {
    if (getGrid()) showPage(reset ? 1 : currentVp(), {});
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initPager(false); });
  } else {
    initPager(false);
  }

  /* Called by collection-filter.js after a filter / sort AJAX refresh. */

  window.njCollectionCardsInit = function (root) {
    root = root || document;
    if (typeof window.getATCelement === 'function') {
      window.getATCelement(root);
    }
    initPager(true); /* new result set -> always start at its first page */
  };
})();
